// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useContext, useRef, useState } from 'react';
import LevelMeter from '../../LevelMeter';
import Level from '../../common/Level';
import CommonContext from '../../../contexts/CommonContext';
import { S } from './styles';
import { FormattedMessage } from 'react-intl';

interface LevelDropdownProps {
  levelId: number;
  updateLevelId: (nextLevelId: number) => void;
}

function LevelCondition(props: LevelDropdownProps): JSX.Element {
  const {
    levelId,
    updateLevelId,
    ...otherProps
  } = props;

  const { levels } = useContext(CommonContext);
  const [isOpened, setIsOpened] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleDrop = () => {
    if (isOpened) {
      window.removeEventListener('click', handleClick, true);
      setIsOpened(false)
    } else {
      window.addEventListener('click', handleClick, true);
      setIsOpened(true);
    }
  }

  const handleClick = (event: MouseEvent) => {
    if (!containerRef.current?.contains(event.target as Node)) {
      setIsOpened(false);
    }
  }

  return (
    <S.Container onClick={handleDrop} ref={containerRef} {...otherProps}>
      {
        levelId !== 0 ? (
          <>
            <LevelMeter levelId={levelId} />
            <S.OptionTitle><Level id={levelId} /></S.OptionTitle>
          </>
        ) : <S.Current><FormattedMessage id="C004" /></S.Current>
      }
      <S.DropdownArrow isOpened={isOpened} />
      {
        isOpened && <S.DropContainer>
          <S.DropRow
            onClick={() => updateLevelId(0)}
          >
            <LevelMeter levelId={0} />
            <S.OptionTitle><FormattedMessage id="C008" /></S.OptionTitle>
          </S.DropRow>
          {
            levels.map((level) => (
              <S.DropRow
                key={level.id}
                onClick={() => updateLevelId(level.id)}
              >
                <LevelMeter levelId={level.id} />
                <S.OptionTitle><Level id={level.id} /></S.OptionTitle>
              </S.DropRow>
            ))
          }
        </S.DropContainer>
      }
    </S.Container>
  )
}

export { LevelCondition as default };
